import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import { GET_ALL_MESSAGE_LIST, CREATE_MESSAGE_INSERT, CREATE_CASE_COMMANTS, GET_CASE_COMMENT_LIST, GET_CENTRIC_MESSAGE_LIST } from "../../../../Urls";

const initialState = {
    messageList: { data: [], loader: false },
    messageInfo: { data: [], loader: false },
    createCaseMessageData: { data: {}, loader: false, successMessage: "" },
    selectedMesage: {},
    createMessageCommentData: { data: {}, loader: false, successMessage: "" },
    centricMessageList: { data: [], loader: false },
}

export const getMessageList = createAsyncThunk(
    "app/get/getMessageList",
    async ({ crm_contact_id, case_id = '' }) => {
        const resMessageList = await axios.get(GET_ALL_MESSAGE_LIST + crm_contact_id + `&case_id=${case_id}`);
        return resMessageList;
    }
);

export const getMessageInfo = createAsyncThunk(
    "app/get/getMessageInfo",
    async ({ crm_contact_id, case_id = '' }) => {
        const resMessageList = await axios.get(GET_ALL_MESSAGE_LIST + crm_contact_id + `&case_id=${case_id}`);
        return resMessageList;
    }
);

export const createMessage = createAsyncThunk(
    "app/get/createCaseComment",
    async (data) => {
        const response = await axios.post(CREATE_MESSAGE_INSERT, { ...data });
        return response;
    }
);


export const getMessageCaseList = createAsyncThunk(
    "app/get/getMessageCaseList",
    async (crm_contact_id) => {
        const resMessageList = await axios.get(GET_CASE_COMMENT_LIST + crm_contact_id);
        return resMessageList;
    }
);

export const createMessageCase = createAsyncThunk(
    "app/get/createMessageCaseComment",
    async (data) => {
        const response = await axios.post(CREATE_CASE_COMMANTS, { ...data });
        return response;
    }
);

export const getCentricMessageList = createAsyncThunk(
    "app/get/getAllMessages",
    async (data) => {
        const response = await axios.post(GET_CENTRIC_MESSAGE_LIST, { ...data });
        return response;
    }
);

export const mesageListSlice = createSlice({
    name: "app/messageListSlice",
    initialState,
    reducers: {
        selectedMesage: (state, action) => {
            state.selectedMesage = action?.payload;
        },
        clearSuccessMessage: (state) => {
            state.createMessageCommentData.successMessage = "";
            state.createCaseMessageData.successMessage = "";

        },
    },

    extraReducers: (builder) => {
        builder

            // get message list
            .addCase(getMessageList.pending, (state) => {
                state.messageList.loader = true;
            })
            .addCase(getMessageList.fulfilled, (state, action) => {
                state.messageList.loader = false;
                state.messageList.data = action?.payload?.data?.data;
            })
            .addCase(getMessageList.rejected, (state) => {
                state.messageList.loader = false;
            })

            //get message info
            .addCase(getMessageInfo.pending, (state) => {
                state.messageInfo.loader = true;
            })
            .addCase(getMessageInfo.fulfilled, (state, action) => {
                state.messageInfo.loader = false;
                state.messageInfo.data = action?.payload?.data?.data;
            })
            .addCase(getMessageInfo.rejected, (state) => {
                state.messageInfo.loader = false;
            })

            .addCase(createMessage.pending, (state) => {
                state.createCaseMessageData.loader = true;
            })
            .addCase(createMessage.fulfilled, (state, action) => {
                state.createCaseMessageData.loader = false;
                state.createCaseMessageData.data = action?.payload?.data?.data;
                state.createCaseMessageData.successMessage = "Message created successfully!";
            })
            .addCase(createMessage.rejected, (state) => {
                state.createCaseMessageData.loader = false;
                state.createCaseMessageData.data = {};
                state.createCaseMessageData.successMessage =
                    "Failed to create message!";
            })

            //getCentricMessageList
            .addCase(getCentricMessageList.pending, (state) => {
                state.centricMessageList.loader = true;
            })
            .addCase(getCentricMessageList.fulfilled, (state, action) => {
                state.centricMessageList.loader = false;
                state.centricMessageList.data = action?.payload?.data?.data;
            })
            .addCase(getCentricMessageList.rejected, (state) => {
                state.centricMessageList.loader = false;
                state.centricMessageList.data = [];
            })


            .addCase(createMessageCase.pending, (state) => {
                state.createMessageCommentData.loader = true;
            })
            .addCase(createMessageCase.fulfilled, (state, action) => {
                state.createMessageCommentData.loader = false;
                state.createMessageCommentData.successMessage = "Comments added successfully!";
                state.createMessageCommentData.data = action?.payload?.data?.data;
            })
            .addCase(createMessageCase.rejected, (state) => {
                state.createCaseMessageData.loader = false;
                state.createMessageCommentData.data = {};
                state.createMessageCommentData.successMessage =
                    "Failed to add comments!";
            });
    }
});

export const getReduxMessageList = (state) => state.messageSlice.messageList;
export const {
    clearSuccessMessage,
} = mesageListSlice.actions;

export default mesageListSlice.reducer;